import {
  Input,
  FormField,
  SpaceBetween,
  Container,
  TextContent,
  DatePicker,
  Select,
  Tiles,
  Textarea,
  Box,
  ColumnLayout,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { COMMON_LABELS } from "../default-constants";

//=================================================================
// GW契約内容登録・更新の画面フォーマット
//概要：GW契約内容登録・更新の画面フォーマット
//
//FormCpInfoBlock:事業者情報の画面フォーマット
//FormContractDetailsBlock:GW契約内容の画面フォーマット
//==================================================================

export const FormCpInfoBlock = (props: any) => {
  return (
    <FormField stretch>
      {/*=== 事業者情報の画面はここから ===*/}
      <Container>
        <TextContent>
          <h2>{LABELS.COMPANY_INFO_LABEL}</h2>
        </TextContent>
        <SpaceBetween direction="horizontal" size="xs">
          <SpaceBetween size="xxxs">
            <TextContent>
              <h4>{LABELS.COMPANY_CODE}</h4>
            </TextContent>
            <TextContent>
              <h4>{LABELS.CORPORATE_NUMBER}</h4>
            </TextContent>
            <TextContent>
              <h4>{LABELS.COMPANY_NAME}</h4>
            </TextContent>
          </SpaceBetween>
          <SpaceBetween size="xxxs">
            <TextContent>
              <p>{props.cpCode}</p>
            </TextContent>
            <TextContent>
              <p>{props.copNum}</p>
            </TextContent>
            <TextContent>
              <p>{props.cpNameKana}</p>
            </TextContent>
            <TextContent>
              <p>{props.cpName}</p>
            </TextContent>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </FormField>
  );
};

export const FormContractDetailsBlock = (props: any) => {
  return (
    <Container>
      <TextContent>
        <h2>{LABELS.CONTRACT_INFO_LABEL}</h2>
      </TextContent>
      <SpaceBetween size="xs">
        {/* ==GWコード_画面の設定 ==*/}
        <ColumnLayout columns={5}>
          <FormField label={LABELS.CORP_GW_CODE}>
            <Input value={props.gwCord} readOnly />
          </FormField>
        </ColumnLayout>
        {/* ==GW名_画面の設定==*/}
        <ColumnLayout columns={3}>
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.CORP_GW_NAME}</Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
            errorText={props.gwNameErrorMsg}
            constraintText="100文字以内"
          >
            <Input
              onChange={({ detail }) => {
                props.setGwName(detail.value);
                props.gwNameOnChange(detail.value);
                props.setChangeFlag(true);
              }}
              value={props.gwName}
              placeholder={LABELS.GW_NAME_SMP}
            />
          </FormField>
        </ColumnLayout>
        {/* ==契約サービス_画面の設定 ==*/}
        <ColumnLayout columns={3}>
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.CORP_GW_SERVICE}</Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
          >
            <Select
              options={props.ServiceItems}
              onChange={(event: any) => {
                props.setSelectedGwService(event.detail.selectedOption);
                props.setChangeFlag(true);
              }}
              selectedOption={props.selectedGwService}
              selectedAriaLabel="Selected"
            />
          </FormField>
        </ColumnLayout>
        {/* ==契約ステータス_画面の設定 ==*/}

        <SpaceBetween size="s">
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.CORP_GW_STATUS}</Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
            errorText={props.gwStatusErrorMsg}
          >
            <Tiles
              onChange={({ detail }) => {
                props.gwStatusOnChange(detail.value);
                props.setValueGwStatus(detail.value);
                props.setChangeFlag(true);
              }}
              value={props.valueGwStatus}
              columns={2}
              items={props.contractItems}
            />
          </FormField>
        </SpaceBetween>

        {/* == 申し込み開始日_画面の設定 ==*/}
        <FormField
          stretch
          label={
            <SpaceBetween direction="horizontal" size="xs">
              <Box variant="strong">{LABELS.CORP_GW_START_DATE}</Box>
              <Box variant="small" color="text-status-error">
                {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
              </Box>
            </SpaceBetween>
          }
          errorText={props.gwStartDateErrorMsg}
        >
          <DatePicker
            onChange={({ detail }) => {
              props.setValueStartDate(detail.value);
              props.gwStartDateOnChange(detail.value);
              props.setChangeFlag(true);
            }}
            value={props.valueStartDate}
            openCalendarAriaLabel={(selectedDate) =>
              "Choose certificate expiry date" +
              (selectedDate ? `, selected date is ${selectedDate}` : "")
            }
            nextMonthAriaLabel="Next month"
            placeholder="YYYY/MM/DD"
            previousMonthAriaLabel="Previous month"
            todayAriaLabel="Today"
          />
        </FormField>
        {/* ==契約利用料率_画面の設定 ==*/}

        <FormField
          stretch
          label={LABELS.CORP_GW_CONTRACTED_USAGE_RATE}
          errorText={props.contractedUsageRateErrorMsg}
          constraintText="2000文字以内"
        >
          <Textarea
            value={props.valueGwContractedUsageRate}
            onChange={(event) => {
              props.contractedUsageRateCheck(event.detail.value);
              props.setValueGwContractedUsageRate(event.detail.value);
              props.setChangeFlag(true);
            }}
          />
        </FormField>

        {/* ==口座情報管理要否_画面の設定 ==*/}
        <SpaceBetween size="s">
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">
                  {LABELS.CORP_GW_ACCOUNT_INFO_MANAGEMENT}
                </Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
          >
              <Tiles
                onChange={({ detail }) => {
                  props.setValueGwManagement(detail.value);
                  props.setChangeFlag(true);
                }}
                items={props.necessaryItems}
                value={props.valueGwManagement}
                columns={2}
              ></Tiles>
          </FormField>
          {/* ==IPID事前払出要否_画面の設定 ==*/}
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">
                  {LABELS.CORP_GW_IPID_ADVANCE_PAYMENT}
                </Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
          >
            <Tiles
                onChange={({ detail }) => {
                  props.setValueGwPayment(detail.value);
                  props.setChangeFlag(true);
                }}
                items={props.necessaryItems}
                value={props.valueGwPayment}
                columns={2}
              ></Tiles>
          </FormField>
        </SpaceBetween>
      </SpaceBetween>
    </Container>
  );
};
